import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export interface EmptyStateProps {
    icon: ReactNode;
    title: string;
    body: string;
    action?: ReactNode;
}

export default function EmptyState({ icon, title, body, action }: EmptyStateProps) {
    return (
        <Box
            component="section"
            sx={{
                p: 3,
                borderRadius: 4,
                bgcolor: "background.paper",
                border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
                textAlign: "left",
            }}
        >
            <Box
                sx={{
                    width: 52,
                    height: 52,
                    borderRadius: 3,
                    display: "grid",
                    placeItems: "center",
                    color: "primary.main",
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                    mb: 2,
                    "& svg": { fontSize: 30 },
                }}
            >
                {icon}
            </Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 850 }}>
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, mb: action ? 2 : 0 }}>
                {body}
            </Typography>
            {action}
        </Box>
    );
}

